var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 3.78836,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1710_36457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.67383 13.4661C5.67383 13.4661 6.38216 12.7578 8.50716 12.7578C10.6322 12.7578 12.0488 14.1745 14.1738 14.1745C16.2988 14.1745 17.0072 13.4661 17.0072 13.4661V4.96615C17.0072 4.96615 16.2988 5.67448 14.1738 5.67448C12.0488 5.67448 10.6322 4.25781 8.50716 4.25781C6.38216 4.25781 5.67383 4.96615 5.67383 4.96615V13.4661Z",
    stroke: "#616E85",
    strokeWidth: 1.26666,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67383 18.4251V13.4668",
    stroke: "#616E85",
    strokeWidth: 1.26666,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1710_36457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(2.8418 2.8418)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagDark);
export default __webpack_public_path__ + "static/media/FlagDark.1a6097bc6248e23d242c7c5a909a8a1b.svg";
export { ForwardRef as ReactComponent };